export default {
      id: "cscs-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "sprite.svg#cscs",
      toString: function () {
        return this.url;
      }
    }